import React from "react";
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";
import { COLORS } from "components/consts";

interface SkipTourDialogProps {
  open: boolean;
  onSkip: () => void;
  onContinue: () => void;
}

export const SkipTourDialog = ({
  open,
  onSkip,
  onContinue,
}: SkipTourDialogProps) => (
  <Dialog
    open={open}
    onClose={onContinue}
    PaperProps={{
      sx: { borderRadius: 3, p: 1, maxWidth: 400, width: "100%" },
    }}
  >
    <DialogTitle sx={{ textAlign: "center", pt: 3, pb: 1 }}>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: 1.5,
        }}
      >
        <Box
          sx={{
            width: 56,
            height: 56,
            borderRadius: "50%",
            backgroundColor: `${COLORS.Romance}20`,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <ExploreOutlinedIcon sx={{ color: COLORS.Romance, fontSize: 28 }} />
        </Box>
        <Typography variant="h6" fontWeight={700}>
          Skip the tour?
        </Typography>
      </Box>
    </DialogTitle>
    <DialogContent sx={{ textAlign: "center", px: 4 }}>
      <Typography variant="body2" color="text.secondary">
        You&apos;re about to leave the onboarding guide. You can always restart
        it later.
      </Typography>
    </DialogContent>
    <DialogActions sx={{ px: 3, pb: 3, gap: 1 }}>
      <Button
        onClick={onContinue}
        variant="outlined"
        sx={{
          flex: 1,
          borderColor: COLORS.Romance,
          color: COLORS.Romance,
          borderRadius: 2,
          fontWeight: 600,
          textTransform: "none",
          "&:hover": {
            borderColor: COLORS.Romance,
            backgroundColor: `${COLORS.Romance}10`,
          },
        }}
      >
        Continue Tour
      </Button>
      <Button
        onClick={onSkip}
        variant="contained"
        sx={{
          flex: 1,
          backgroundColor: COLORS.Romance,
          borderRadius: 2,
          fontWeight: 600,
          textTransform: "none",
          "&:hover": { backgroundColor: COLORS.Romance },
        }}
      >
        Skip Tour
      </Button>
    </DialogActions>
  </Dialog>
);
